class CartEstimatedDelivery extends HTMLElement {
  connectedCallback() {
    const dateElement = this.querySelector('[data-ref="date"]');
    if (!dateElement) return;

    const minDays = Number.parseInt(this.dataset.minDays, 10) || 2;
    const maxDays = Number.parseInt(this.dataset.maxDays, 10) || 4;
    const showMin = this.dataset.showMin !== 'false';
    const locale = this.dataset.locale || document.documentElement.lang || 'fr';

    const today = new Date();
    const endDate = this.#addBusinessDays(today, maxDays);
    const formattedEnd = this.#formatDate(endDate, locale);

    if (!showMin) {
      dateElement.textContent = formattedEnd;
      return;
    }

    const startDate = this.#addBusinessDays(today, minDays);
    const formattedStart = this.#formatDate(startDate, locale);
    dateElement.textContent = `${formattedStart} - ${formattedEnd}`;
  }

  #addBusinessDays(date, days) {
    let counter = 0;
    const newDate = new Date(date.getTime());

    while (counter < days) {
      newDate.setDate(newDate.getDate() + 1);

      if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
        counter++;
      }
    }

    return newDate;
  }

  #formatDate(date, locale) {
    const language = locale.toLowerCase().startsWith('en') ? 'en' : 'fr';
    const daysByLanguage = {
      fr: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    };
    const days = daysByLanguage[language];
    const day = days[date.getDay()];
    const dayNumber = String(date.getDate()).padStart(2, '0');
    const monthNumber = String(date.getMonth() + 1).padStart(2, '0');

    if (language === 'en') {
      return `${day} ${monthNumber}/${dayNumber}`;
    }

    return `${day} ${dayNumber}/${monthNumber}`;
  }
}

if (!customElements.get('cart-estimated-delivery')) {
  customElements.define('cart-estimated-delivery', CartEstimatedDelivery);
}
